import { TutorialTooltip } from './tutorial-tooltip';

export class TutorialSequence {
  id: string;
  tooltips: TutorialTooltip[];
  maxSteps: number;

  constructor(id: string, maxSteps: number) {
    this.id = id;
    this.maxSteps = maxSteps;
    this.tooltips = [];
    for (let i = 1; i <= maxSteps; i++) {
      this.tooltips.push(new TutorialTooltip(id, i));
    }
  }
}
